var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":("https://scoolfacts.com/?bearer=" + _vm.token + "&application=" + _vm.application + "&language=" + _vm.language),"frameborder":"0","height":"100%","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }